export abstract class APIModel {
    id?: number;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string;

    getCreatedAt () {
        if (!this.createdAt) return false
        return new Date(this.createdAt)
    }

    getupdatedAt () {
        if (!this.updatedAt) return false
        return new Date(this.updatedAt)
    }

    getDeletedAt () {
        if (!this.deletedAt) return false
        return new Date(this.deletedAt)
    }

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
    }) {
        this.id = params.id
        this.createdAt = params.createdAt
        this.updatedAt = params.updatedAt
        this.deletedAt = params.deletedAt
    }
}
